<template>
  <div class="ct-mini-box" :class="`bg-${boxBg}`">

      <div class="title-box text-center" :class="`bg-${titleBg}`" :style="`width: ${titleWidth}%`">
        <span :class="`text-${titleColor}`">{{ title }}</span>
      </div>
      <div class="title-box text-center " :style="`width: ${valueWidth}%`">
        <span :class="`text-${valueColor}`" :title="`${titleValue || ''}`">{{ value }}</span>
        <span :class="`text-${valueColor}`" v-if="!$_utils.isEmpty(subValue)">{{ subValue }}</span>
      </div>


  </div>
</template>

<script>
export default {
  props: {
    boxBg: {type: String, default: 'white'},
    titleBg: {type: String, default: 'white'},
    titleColor: {type: String, default: 'white'},
    titleWidth: {type: Number, default: 0},
    title: String,
    titleValue: String,
    valueColor: {type: String, default: 'white'},
    valueWidth: {type: Number, default: 0},
    value: String,
    subValue: String
  },
  data() {
    return {

    }
  },
  computed: {
  }
}
</script>
